import React from 'react';
import { formatDateTime, statusColorClass } from '../lib/openPlatformFormatters';

const WebhookTable = ({ items = [], onCreate, onTest, onDisable, onViewDeliveries }) => (
  <div className="rounded-lg border border-slate-800 bg-slate-900/70">
    <div className="flex items-center justify-between border-b border-slate-800 px-3 py-2">
      <h3 className="text-sm font-semibold text-slate-100">Webhook Subscriptions</h3>
      <button type="button" onClick={onCreate} className="rounded border border-cyan-400/40 bg-cyan-500/10 px-2 py-1 text-xs font-semibold text-cyan-200">
        Buat Webhook
      </button>
    </div>
    <div className="overflow-x-auto">
      <table className="min-w-full text-xs">
        <thead className="bg-slate-950/80 text-slate-400">
          <tr>
            <th className="px-3 py-2 text-left">Target URL</th>
            <th className="px-3 py-2 text-left">Event</th>
            <th className="px-3 py-2 text-left">Status</th>
            <th className="px-3 py-2 text-left">Updated</th>
            <th className="px-3 py-2 text-left">Aksi</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.webhookId} className="border-t border-slate-800 text-slate-200">
              <td className="px-3 py-2">
                <p className="max-w-[320px] truncate text-slate-100">{item.targetUrl}</p>
                <p className="text-[11px] text-slate-500">{item.webhookId}</p>
              </td>
              <td className="px-3 py-2">
                <div className="flex flex-wrap gap-1">
                  {(item.eventTypes || []).map((eventType) => (
                    <span key={eventType} className="rounded border border-indigo-400/35 bg-indigo-500/10 px-2 py-0.5 text-[11px] text-indigo-200">{eventType}</span>
                  ))}
                </div>
              </td>
              <td className="px-3 py-2">
                <span className={`inline-flex rounded border px-2 py-0.5 text-[11px] font-semibold ${statusColorClass(item.isActive ? 'ACTIVE' : 'DISABLED')}`}>
                  {item.isActive ? 'ACTIVE' : 'DISABLED'}
                </span>
              </td>
              <td className="px-3 py-2">{formatDateTime(item.updatedAt)}</td>
              <td className="px-3 py-2">
                <div className="flex gap-2">
                  <button type="button" onClick={() => onTest(item.webhookId)} className="rounded border border-amber-400/40 bg-amber-500/10 px-2 py-1 text-[11px] text-amber-200">Test</button>
                  <button type="button" onClick={() => onDisable(item.webhookId)} className="rounded border border-red-400/40 bg-red-500/10 px-2 py-1 text-[11px] text-red-200">Disable</button>
                  <button type="button" onClick={() => onViewDeliveries(item.webhookId)} className="rounded border border-cyan-400/40 bg-cyan-500/10 px-2 py-1 text-[11px] text-cyan-200">Delivery</button>
                </div>
              </td>
            </tr>
          ))}
          {items.length === 0 ? (
            <tr>
              <td colSpan={5} className="px-3 py-6 text-center text-slate-500">Belum ada webhook.</td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </div>
  </div>
);

export default WebhookTable;
